<template>
  <modal transition="pop-out" name="new-ordered-item-modal" :width="500" :height="180">
    <div class="w-full">
      <form :model="form" ref="form" :label-position="labelPosition" class="rounded px-8 pt-6" @submit.prevent>
        <el-row :gutter="10" class="pb-4">
          <el-col :span="18">
            <label class="text-sm block">Item</label>
            <el-select class="w-full" v-model="selectedItemId" filterable placeholder="Please select an item">
              <el-option
                v-for="item of items"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <label class="text-sm block">Quantity</label>
            <el-input class="w-full" clearable v-model="selectedItemQty" type="number"></el-input>
          </el-col>
        </el-row>
        <div class="">
          <el-button @click="submit('form')" type="primary" :loading="adding">Add</el-button>&nbsp;
          <el-button @click="closeDialog" type="text">Close</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewOrderItemForm',
  props: ['order'],
  data() {
    return {
      error: false,
      adding: false,
      labelPosition: 'top',
      form: {},
      selectedItemId: '',
      selectedItemQty: '',
    };
  },
  computed: {
    items() {
      return this.$store.state.InventoryModule.Products.products;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      await this.$store.dispatch('InventoryModule/Products/fetchPluckedProducts');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
    this.loading = false;
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('new-ordered-item-modal');
    },
    async submit(form) {
      this.errors = this.formValidation(this.form);

      if (this.errors.length === 0) {
        const item = this.items.filter(el => el.id === this.selectedItemId)[0];
        const formData = {
          order_id: this.order.id,
          item_id: this.selectedItemId,
          quantity: this.selectedItemQty,
          item_name: item.name,
          item_price: item.price,
          item_weight: item.weight,
          item_preview: item.image,
        };

        try {
          this.adding = true;

          await this.$store.dispatch('OrderModule/newOrderItem', { orderedItem: formData });
          this.$modal.hide('new-ordered-item-modal');
          this.$notify.success({
            title: 'Success',
            message: 'Order item successfully added',
          });
          this.$refs[form].reset();
        } catch (e) {
          this.adding = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.adding = false;
      }
      this.error = false;
    },
  },
};
</script>

<style scoped>

</style>
